import React from 'react';
import styled from 'styled-components';

import { media } from '@/styles/theme';
import { otherColors } from '@/styles/colors';
import {
  STICKY_SHADOW_HEIGHT_MOBILE,
  WEEKDAY_HEADER_HEIGHT,
  Z_INDEX_STICKY_SHADOW,
  Z_INDEX_STICKY_SHADOW_COVER,
  Z_INDEX_STICKY_SHADOW_PLACEHOLDER,
} from '@/config/variables';
import { getCalendarMessageHeight } from '@/helpers';

const StickyShadow = (
  props: React.HTMLAttributes<HTMLDivElement> & { isCalendarMessageDisplayed?: boolean },
): React.ReactElement => <StickyShadowElement {...props} />;

export { StickyShadow };

const StickyShadowElement = styled.div<{ isCalendarMessageDisplayed?: boolean }>`
  position: sticky;
  top: ${({ isCalendarMessageDisplayed }) =>
    `calc(${STICKY_SHADOW_HEIGHT_MOBILE}px + ${getCalendarMessageHeight(isCalendarMessageDisplayed, true)}px)`};
  left: 0;
  z-index: ${Z_INDEX_STICKY_SHADOW};
  height: 4px;
  width: 100%;
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(255, 255, 255, 0) 100%);

  transition: top 0.2s linear;

  ${media.tablet} {
    top: ${({ isCalendarMessageDisplayed }) =>
      `calc(${WEEKDAY_HEADER_HEIGHT}px + ${getCalendarMessageHeight(isCalendarMessageDisplayed)}px)`};
  }
`;

const StickyShadowCover = styled.div`
  position: absolute;
  top: -4px;
  left: 0;
  z-index: ${Z_INDEX_STICKY_SHADOW_COVER};
  width: 100%;
  height: 4px;
  background-color: #fff;

  .current-day & {
    background-color: ${otherColors.calendar.currentDay};
  }

  .dls-day & {
    background-color: ${otherColors.calendar.dlsDay};
  }
`;

const StickyPlaceholder = styled.div<{ isCalendarMessageDisplayed?: boolean }>`
  background-color: #fff;
  position: sticky;
  top: ${({ isCalendarMessageDisplayed }) => getCalendarMessageHeight(isCalendarMessageDisplayed, true)}px;
  z-index: ${Z_INDEX_STICKY_SHADOW_PLACEHOLDER};
  height: ${STICKY_SHADOW_HEIGHT_MOBILE}px;
  width: 100%;

  transition: height 0.2s linear;

  ${media.tablet} {
    top: ${({ isCalendarMessageDisplayed }) => getCalendarMessageHeight(isCalendarMessageDisplayed)}px;
    height: ${WEEKDAY_HEADER_HEIGHT}px;
  }
`;

StickyShadow.Cover = StickyShadowCover;
StickyShadow.Placeholder = StickyPlaceholder;
